import { apiSlice } from "../../api/apiSlice";

export const assignmentMarkApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAssignmentMark: builder.query({
      query: () => `/assignmentMark`,
      providesTags: ["AssignmentMark"],
    }),

    editAssignmentMark: builder.mutation({
      query: ({ id, data }) => ({
        url: `/assignmentMark/${id}`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: ["AssignmentMark"],
    }),
  }),
});

export const { useGetAssignmentMarkQuery, useEditAssignmentMarkMutation } =
  assignmentMarkApi;
